export default __webpack_public_path__ + "static/media/vip-logo-gold-current.aa6f72b2.webp";